const useIsRecurring = form => {
  return !!form.watch("recurring.days");
};

export default useIsRecurring;